export const pastelColors = [
  '#FF9AA2', // pastel pink:
  '#7EAAC7', // pastel blue:
  '#66E2D3', // pastel green:
  '#D8B384', // pastel beige:
  '#A39EC9', // pastel purple:
  '#FF8C42', // pastel orange:
  '#70D6B3', // pastel mint:
  '#FF6F61', // pastel coral:
  '#9F94F0', // pastel lavender:
  '#FFA07A', // pastel peach:
];
